export default __webpack_public_path__ + "static/media/mauquenchy2.daf4a201.jpg";